import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

interface LL152Search {
  /**
   * Optional pre-applied subcycle filter. The dashboard upcoming-obligations
   * strip deep-links here as `?subcycle=D` so the demo lands on the wave
   * already filtered. Anything other than `A` / `B` / `C` / `D` is ignored
   * by the page and falls back to "all".
   */
  subcycle?: "A" | "B" | "C" | "D";
}

// Wave-17 Item 1.1 — lazy-loaded route chunk. Search-param validation
// stays eager so the router can hydrate without paying for the page bundle.
export const Route = createFileRoute("/portal/compliance/ll152")({
  component: lazyRouteComponent(
    () => import("@/pages/Portal/Compliance/LL152/Page"),
  ),
  validateSearch: (raw: Record<string, unknown>): LL152Search => {
    const sub = raw.subcycle;
    if (sub === "A" || sub === "B" || sub === "C" || sub === "D") {
      return { subcycle: sub };
    }
    return {};
  },
});
